import {type FilterKey, type ValueFilter} from '../../../util/filterTypes';
import {type MongoFieldFilter} from '../../../util/mongoTypes';

type artifactFilterFieldName = 'alias' | 'tag';

export const getValueFromArtifactFilterString = (
  filterString: string | undefined,
  name: artifactFilterFieldName
): string => {
  if (!filterString) {
    return '';
  }
  let filterParsed: any;
  try {
    filterParsed = JSON.parse(filterString);
    if (Object.prototype.hasOwnProperty.call(filterParsed, 'filter')) {
      filterParsed = JSON.parse(filterParsed.filter);
    }
  } catch (e) {
    console.warn(
      `error parsing trigger filter json.\nfilter: ${filterString}\nerror: ${e}`
    );
    return '';
  }
  try {
    const andClauses: MongoFieldFilter[] = filterParsed?.$or?.[0]?.$and ?? [];
    const match = andClauses.find(clause => clause?.[name] != null)?.[name];
    if (match == null) {
      return '';
    }
    return typeof match === 'string'
      ? match
      : String(match.$regex ?? match.$eq ?? '');
  } catch (e) {
    console.warn(`error getting ${name} from filter: ${e}`);
  }
  return '';
};

export const createArtifactFilter = (
  name: artifactFilterFieldName,
  value: string
): ValueFilter<FilterKey> => {
  return {
    key: {section: 'artifact', name: name},
    op: 'REGEX',
    value: value,
  };
};
